/* ═══════════════════════════════════════════════════════════════════════
   TAIBI · lo stato dell'header sopra l'hero
   File nostro. Fa una cosa sola: dire alla pagina se è ancora in cima.
   `<html class="taibi-scorso">` è l'interruttore, e il CSS dell'hero ci
   attacca il passaggio dell'header da trasparente a pieno.

   Perché una SENTINELLA e non un listener di scorrimento: un
   IntersectionObserver si sveglia due volte in tutta la pagina — quando la
   soglia viene superata e quando si torna su — invece che a ogni pixel.
   E la soglia è **14px**, non l'altezza dell'header né la fine dell'hero:
   la trasparenza è il trattamento del PRIMO ISTANTE, non di tutta la
   sezione. Appena si scorre, l'header prende il fondo anche se l'hero è
   ancora tutto lì sotto. Così l'altezza dell'header non entra nel calcolo e
   non va ricalcolata a ogni breakpoint.

   ⚠️ Questo file lo carica l'HERO, non l'header: su una pagina senza hero
   l'header è pieno e basta, e nessuno stato serve.
   ═══════════════════════════════════════════════════════════════════════ */

if (!customElements.get('taibi-sentinella')) {
  customElements.define(
    'taibi-sentinella',
    class TaibiSentinella extends HTMLElement {
      connectedCallback() {
        /* Ripiego onesto: senza IntersectionObserver la pagina resta nello
           stato «scorso», cioè header pieno. Un header trasparente che non
           torna mai pieno sarebbe illeggibile appena la foto finisce. */
        if (!('IntersectionObserver' in window)) {
          document.documentElement.classList.add('taibi-scorso');
          return;
        }

        this.osservatore = new IntersectionObserver(
          (voci) => {
            document.documentElement.classList.toggle('taibi-scorso', !voci[0].isIntersecting);
          },
          { threshold: 0 }
        );

        this.osservatore.observe(this);
      }

      disconnectedCallback() {
        if (this.osservatore) this.osservatore.disconnect();
        /* ⚠️ Nell'editor una sezione tolta lascerebbe la classe accesa sul
           documento, e l'header resterebbe pieno su una pagina che non ha
           più l'hero. Si pulisce uscendo. */
        document.documentElement.classList.remove('taibi-scorso');
      }
    }
  );
}
